import { render, staticRenderFns } from "./FormatListBulleted.vue?vue&type=template&id=5c444520"
import script from "./FormatListBulleted.vue?vue&type=script&lang=js"
export * from "./FormatListBulleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports